<template>
  <section class="inventory">
    <div class="container">
      <h2>
        Canada’s Largest Inventory
      </h2>

      <p>
        We can help you find your dream car thanks to our network of hundreds of Certified Dealerships across Canada.
      </p>

      <div class="row row--gutter-40">
        <div
          v-for="(vehicle, index) in vehicles"
          :key="index"
          class="col col--xs-6 col--sm-3 inventory__col"
        >
          <div class="inventory__vehicle">
            <h3>
              {{ vehicle.title }}
            </h3>

            <div
              class="inventory__img-wrapper"
              v-data-layer
              :data-layer="vehicle.dataLayer"
              @click="handleVehicleClick(vehicle.type)"
            >
              <img
                class="inventory__img"
                :src="vehicle.image"
              >
            </div>

            <p class="inventory__text">
              <small>{{ vehicle.text }}</small>
            </p>

          </div>
          <p class="inventory__link no-margin">
            <a
              v-data-layer
              :data-layer="vehicle.dataLayer"
              @click="handleVehicleClick(vehicle.type)"
            >
              {{ vehicle.linkText }}
            </a>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  // Name
  name: 'inventory',

  // Data
  data () {
    return {
      vehicles: [{
        title: 'Cars',
        type: 'Car',
        dataLayer: 'vehicle_type_car_landed',
        image: require('@/assets/img/landing-page/inventory/light-blue-background/car.jpg'),
        text: 'From fuel efficient commuters to high powered sports cars and luxury sedans, we can help you find the perfect car for your situation.',
        linkText: 'Shop for a Car'
      }, {
        title: 'Trucks',
        type: 'Truck',
        dataLayer: 'vehicle_type_truck_landed',
        image: require('@/assets/img/landing-page/inventory/light-blue-background/truck.jpg'),
        text: 'Need to haul a trailer, just like helping your friends move? Our dealers carry a wide variety of midsize and full-size trucks from various manufacturers.',
        linkText: 'Shop for a Truck'
      }, {
        title: 'SUVs',
        type: 'SUV',
        dataLayer: 'vehicle_type_suv_landed',
        image: require('@/assets/img/landing-page/inventory/light-blue-background/suv.jpg'),
        text: 'Looking for something suitable for city driving, but still want that off-road capability? Let us help you get into the perfect SUV. Compact to full-size, we have it!',
        linkText: 'Shop for an SUV'
      }, {
        title: 'Minivans',
        type: 'Van',
        dataLayer: 'vehicle_type_van_landed',
        image: require('@/assets/img/landing-page/inventory/light-blue-background/van.jpg'),
        text: 'With seating for up to 7 and plenty of room for whatever you may need to transport, a minivan makes the perfect family vehicle.',
        linkText: 'Shop for a Minivan'
      }]
    }
  },

  // Methods
  methods: {
    handleVehicleClick (vehicleType) {
      this.$store.updateApplication('car_type', vehicleType)
      this.$emit('vehicle-click')
    }
  }
}
</script>

<style scoped lang="scss">
.inventory {
  &__col {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  &__img-wrapper {
    cursor: pointer;
  }

  &__img {
    width: 100%;
    position: relative;
    display: block;
  }

  &__text,
  &__text small {
    @include breakpoint('mobile-only') {
      line-height: 18px;
    }
  }

  &__link {
    a {
      cursor: pointer;
    }
  }
}
</style>
